// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-date-picker-header {
  margin: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.custom-date-picker-header button {
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 50%;
  padding: 5px 10px;
  font-size: 18px;
  cursor: pointer;
}
.custom-date-picker-header button:hover {
  background-color: #0056b3;
}
.custom-date-picker-header button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.custom-date-picker-header select {
  margin: 0 10px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}
.custom-date-picker-header button {
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 50%;
  padding: 5px 10px;
  font-size: 18px;
  cursor: pointer;
}
.custom-date-picker-header button:hover {
  background-color: #0056b3;
}
.custom-date-picker-header button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.count-plot-container {
  height: 80vh;
  overflow-y: scroll;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
}
.count-plot-container .data-container {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.count-plot-container .data-container .label-container {
  width: 300px;
  height: 40px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  justify-content: flex-end;
}
.count-plot-container .data-container .label-container .label-span {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 300px;
  cursor: pointer;
  text-align-last: right;
}
.count-plot-container .data-container .bar-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.count-plot-container .data-container .bar-container .bar-style {
  height: 30px;
  background-color: #00889b;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
}
.count-plot-container .data-container .bar-container .bar-style .value-style {
  color: #fff;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #EBEFF1;
}

::-webkit-scrollbar-thumb {
  background-color: #B8B8B8;
  border-radius: 20px;
  border: transparent;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #919191;
}`, "",{"version":3,"sources":["webpack://./src/pages/analytics/DisplayPlot.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AAEE;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AAAJ;AAEI;EACE,yBAAA;AAAN;AAGI;EACE,YAAA;EACA,mBAAA;AADN;AAME;EACE,cAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AAJJ;AAQE;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AANJ;AAQI;EACE,yBAAA;AANN;AASI;EACE,YAAA;EACA,mBAAA;AAPN;;AAaA;EACE,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;AAVF;AAYE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAVJ;AAWI;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AATN;AAUM;EACE,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;AARR;AAWI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AATN;AAUM;EACE,YAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AARR;AASQ;EACE,WAAA;AAPV;;AAcA;EACE,WAAA;AAXF;;AAaA;EACE,mBAAA;AAVF;;AAaA;EACE,yBAAA;EACA,mBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,yBAAA;AAVF","sourcesContent":[".custom-date-picker-header {\n  margin: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  // Style the left button (\"<\")\n  button {\n    background-color: #007bff;\n    color: #fff;\n    border: none;\n    border-radius: 50%;\n    padding: 5px 10px;\n    font-size: 18px;\n    cursor: pointer;\n\n    &:hover {\n      background-color: #0056b3;\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n\n  // Style the year and month select dropdowns\n  select {\n    margin: 0 10px;\n    padding: 5px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 16px;\n  }\n\n  // Style the right button (\">\")\n  button {\n    background-color: #007bff;\n    color: #fff;\n    border: none;\n    border-radius: 50%;\n    padding: 5px 10px;\n    font-size: 18px;\n    cursor: pointer;\n\n    &:hover {\n      background-color: #0056b3;\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n}\n\n\n.count-plot-container {\n  height: 80vh;\n  overflow-y: scroll;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 10px;\n\n  .data-container {\n    width: 100%;\n    height: 50px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    .label-container {\n      width: 300px;\n      height: 40px;\n      display: flex;\n      align-items: center;\n      white-space: nowrap;\n      justify-content: flex-end;\n      .label-span {\n        text-overflow: ellipsis;\n        overflow: hidden;\n        width: 300px;\n        cursor: pointer;\n        text-align-last: right;\n      }\n    }\n    .bar-container {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      .bar-style {\n        height: 30px;\n        background-color: #00889b;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding: 5px 10px;\n        .value-style {\n          color: #fff;\n        }\n      }\n    }\n  }\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n}\n::-webkit-scrollbar-track {\n  background: #EBEFF1;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #B8B8B8;\n  border-radius: 20px;\n  border: transparent;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: #919191;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
